module.exports = __webpack_public_path__ + "img/Hong-Kong.c691b29d.png";